import type { ActionReducerMap } from '@ngrx/store';
import { layoutReducer, type LayoutState } from './layout/layout-reducers';
import {
  calendarReducer,
  type CalendarState,
} from './calendar/calendar.reducer';
import {
  authenticationReducer,
  type AuthenticationState,
} from './authentication/authentication.reducer';
import { CompanyReducer, CompanyState } from './company/company.reducer';
import {
  DepartmentReducer,
  DepartmentState,
} from './department/department.reducer';
import { EmployeeReducer, EmployeeState } from './employee/employee.reducer';
import { CustomerReducer, CustomerState } from './customer/customer.reducer';
import { PropertyReducer, PropertyState } from './property/property.reducer';
import { HolidayReducer, HolidayState } from './holiday/holiday.reducer';
import {
  TimesheetReducer,
  TimesheetState,
} from './timesheet/timesheet.reducer';
import { RoleReducer, RoleState } from './roles/roles.reducer';
import { ExpenseReducer, ExpenseState } from './expense/expense.reducer';
import {
  ExpenseVatReducer,
  ExpenseVatState,
} from './expense-vat/expense-vat.reducer';
import {
  ExpenseTypeReducer,
  ExpenseTypeState,
} from './expense-type/expense-type.reducer';
import {
  DashboardReducer,
  DashboardState,
} from './dashboard/dashboard.reducer';
import { ReportReducer, ReportState } from './report/report.reducer';
import {
  MasterReducer,
  MasterState,
} from './configuration/configuration.reducer';
import {
  VehicleCheckReducer,
  VehicleCheckState,
} from './fleet/vehicle-check/vehicle-check.reducer';
import { VehicleReducer, VehicleState } from './fleet/vehicle/vehicle.reducer';
import {
  ItAssetsConfigurationMasterState,
  ItAssetsConfigurationReducer,
} from './itassets-configuration/itAssets-configuration.reducer';
import { ItAssetsReducer, ItAssetsState } from './itassets/itassets.reducer';
import {
  ParkingManagementConfigurationMasterState,
  ParkingManagementConfigurationReducer,
} from './parking-managment-configuration/parking-management-configuration.reducer';
import {
  ParkingManagementState,
  ParkingManagementReducer,
} from './parking-managment/parking-managment.reducer';
import {
  DocumentTypeReducer,
  DocumentTypeState,
} from './configuration/document-type/document-type.reducer';
import {
  HolidayTypeReducer,
  HolidayTypeState,
} from './holiday-type/holiday-type.reducer';
import {
  DocumentReducer,
  DocumentState,
} from './employee/document/document.reducer';
import { SORReducer, SORState } from './configuration/SOR/sor.reducer';
import {
  TicksheetState,
  TicksheetReducer,
} from './ticksheet/ticksheet.reducer';

export interface RootReducerState {
  authentication: AuthenticationState;
  layout: LayoutState;
  Calendar: CalendarState;
  Company: CompanyState;
  Department: DepartmentState;
  Employee: EmployeeState;
  Customer: CustomerState;
  Property: PropertyState;
  Holiday: HolidayState;
  Timesheet: TimesheetState;
  Role: RoleState;
  Expense: ExpenseState;
  ExpenseVat: ExpenseVatState;
  ExpenseType: ExpenseTypeState;
  Dashboard: DashboardState;
  Report: ReportState;
  Master: MasterState;
  VehicleCheck: VehicleCheckState;
  Vehicle: VehicleState;
  ItAssetsConfiguration: ItAssetsConfigurationMasterState;
  ItAssets: ItAssetsState;
  ParkingManagementConfiguration: ParkingManagementConfigurationMasterState;
  ParkingManagement: ParkingManagementState;
  DocumentType: DocumentTypeState;
  HolidayType: HolidayTypeState;
  Document: DocumentState;
  SOR: SORState;
  Ticksheet: TicksheetState;
}

export const rootReducer: ActionReducerMap<RootReducerState> = {
  authentication: authenticationReducer,
  layout: layoutReducer,
  Calendar: calendarReducer,
  Company: CompanyReducer,
  Department: DepartmentReducer,
  Employee: EmployeeReducer,
  Customer: CustomerReducer,
  Property: PropertyReducer,
  Holiday: HolidayReducer,
  Timesheet: TimesheetReducer,
  Role: RoleReducer,
  Expense: ExpenseReducer,
  ExpenseVat: ExpenseVatReducer,
  ExpenseType: ExpenseTypeReducer,
  Dashboard: DashboardReducer,
  Report: ReportReducer,
  Master: MasterReducer,
  VehicleCheck: VehicleCheckReducer,
  Vehicle: VehicleReducer,
  ItAssetsConfiguration: ItAssetsConfigurationReducer,
  ItAssets: ItAssetsReducer,
  ParkingManagementConfiguration: ParkingManagementConfigurationReducer,
  ParkingManagement: ParkingManagementReducer,
  DocumentType: DocumentTypeReducer,
  HolidayType: HolidayTypeReducer,
  Document: DocumentReducer,
  SOR: SORReducer,
  Ticksheet: TicksheetReducer,
};
